import { ContactPageQuery } from '@layouts/contact'
import { withIntercom } from '@utils/tracing/intercom'

const Contact = (props) => {
  return (
    <ContactPageQuery {...props} />
  )
}

Contact.getInitialProps = async ({ query }) => ({ query })

export default withIntercom(Contact)
